export * from './delete-ort.service';
export * from './delete-ort.service.module';